export class ContentieuxSocial {
    id: number;
    hasDocument: boolean; // décision attaquée
    raisonSansDocument: string; // raison sans la décision attaquée
    souhait: string;
    typeLitige: string;
    nomsAdministrations: string;
    objetDemande: string; // titre de demande
    precisionDemande: string; // Obselete
    motifs: string;
    contexteInterventionDecision: string;
    conclusionDALO: string;
    conclusionLitigeAdminCheckbox: boolean;
    conclusionLitigeAdmin: string;
    raisonContestations: Array<RaisonContestation>;
    // reclamer une somme
    pourquoiSommeDue: string;
    montantDuMontant: number;
    conclusionReclamerSommeCondamnerAdmin: boolean;
    conclusionReclamerSommeMajoree: boolean;
    // contester une somme
    typeActe: string;
    raisonAvisDimpositionIrreguliers: Array<RaisonAvisDimpositionIrregulier>;
    faitConduitAuLitige: string;
    raisonPasPayerImpot: string;
    conclusionAvisImpositionImpot: boolean;
    raisonInvalidationTitres: Array<RaisonInvalidationTitre>;
    conclusionContesterSommeTitreEmisIrregulierDes: boolean;
    conclusionContesterSommeTitreEmisIrregulierMontant: number;
    // indemnisation
    faitConduitSituationReparation: string;
    prejudiceEvaluableEnArgents: Array<PrejudiceEvaluableEnArgent>;
    precisionPrejudice: string;
    originePrejudice: string;
    conclusionIndemnisationCondamnerAdmin: boolean;
    conclusionIndemnisationMontant: number;
    conclusionIndemnisationMajoree: boolean;
}

export class RaisonContestation {
    typeRaisonContestationId: number;
    detail: string;
}

export class RaisonInvalidationTitre {
    typeRaisonInvalidationTitreId: number;
    detail: string;
}

export class RaisonAvisDimpositionIrregulier {
    typeRaisonAvisDimpositionIrregulierId: number;
}

export class PrejudiceEvaluableEnArgent {
    typePrejudiceEvaluableEnArgentId: number;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contentieux-social/contentieux-social.model.ts